import React from "react";
import { Skeleton } from "@mui/material";
export {
  PageHeader,
  SectionCard,
  StatCard,
  EmptyState,
  FilterBar,
  TableShell,
} from "../../../ui";

export function LoadingSkeleton({ rows = 3, variant = "cards" }) {
  if (variant === "profile") {
    return (
      <div className="p-4 md:p-6 space-y-4">
        <Skeleton variant="rounded" height={140} sx={{ borderRadius: 3 }} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Skeleton variant="rounded" height={220} sx={{ borderRadius: 3 }} />
          <Skeleton variant="rounded" height={220} sx={{ borderRadius: 3 }} />
        </div>
      </div>
    );
  }

  if (variant === "table") {
    return (
      <div className="p-4 md:p-6 space-y-3">
        <Skeleton variant="text" width={180} height={40} />
        <Skeleton variant="rounded" height={48} sx={{ borderRadius: 3 }} />
        <Skeleton variant="rounded" height={320} sx={{ borderRadius: 3 }} />
      </div>
    );
  }

  return (
    <div className="p-4 md:p-6 space-y-4">
      <Skeleton variant="rounded" height={120} sx={{ borderRadius: 3 }} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton
            key={i}
            variant="rounded"
            height={110}
            sx={{ borderRadius: 3 }}
          />
        ))}
      </div>
      <Skeleton variant="rounded" height={220} sx={{ borderRadius: 3 }} />
    </div>
  );
}

export function StatusChip({ active, label }) {
  const text = label || (active ? "Active" : "Inactive");
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${
        active
          ? "bg-gx-red/10 text-gx-red ring-1 ring-gx-red/20"
          : "bg-gx-canvas text-gx-ink-soft ring-1 ring-gx-border"
      }`}
    >
      {text}
    </span>
  );
}

export function formatMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  return n.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

export function accountBalanceDisplay(value) {
  const balance = Number(value);
  if (!Number.isFinite(balance) || balance === 0) {
    return {
      value: "0",
      hint: "Your account is settled",
      label: "Account Balance",
      accent: "#033b51",
    };
  }

  if (balance > 0) {
    return {
      value: formatMoney(balance),
      hint: "Amount due from you to the gym",
      label: "Amount Due",
      accent: "#D71920",
    };
  }

  return {
    value: formatMoney(Math.abs(balance)),
    hint: "Credit with the gym, adjusted against future charges",
    label: "Account Credit",
    accent: "#033b51",
  };
}

export function formatDate(value, fallback = "-") {
  if (!value) return fallback;
  try {
    const d = new Date(value);
    if (Number.isNaN(d.getTime())) return fallback;
    return d.toLocaleDateString(undefined, {
      month: "short",
      day: "2-digit",
      year: "numeric",
    });
  } catch {
    return fallback;
  }
}

export function initials(name) {
  if (!name) return "?";
  const parts = String(name).trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() || "").join("") || "?";
}
